/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AccessService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Validate access token and get user info
     * @returns any Token is valid
     * @throws ApiError
     */
    public getAccessValidate({
        token,
    }: {
        token: string,
    }): CancelablePromise<{
        userId: string;
        email: string;
        name: string | null;
        trainerId: string;
        isClaimed: boolean;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/access/validate/{token}',
            path: {
                'token': token,
            },
            errors: {
                404: `Invalid token`,
            },
        });
    }

    /**
     * Get all programs accessible via access token
     * @returns any List of programs
     * @throws ApiError
     */
    public getAccessPrograms({
        token,
    }: {
        token: string,
    }): CancelablePromise<{
        programs: Array<{
            id: string;
            createdAt: string;
            updatedAt: string;
            ownerId: string;
            title: string;
            description: string | null;
            creatorId: string | null;
            clientId: string;
            programVideos: Array<any>;
        }>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/access/{token}/programs',
            path: {
                'token': token,
            },
            errors: {
                404: `Invalid token`,
            },
        });
    }

    /**
     * Get specific program via access token
     * @returns any Program details
     * @throws ApiError
     */
    public getAccessProgram({
        token,
        programId,
    }: {
        token: string,
        programId: string,
    }): CancelablePromise<{
        program?: any;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/access/{token}/program/{programId}',
            path: {
                'token': token,
                'programId': programId,
            },
            errors: {
                403: `No access to this program`,
                404: `Program not found or invalid token`,
            },
        });
    }

    /**
     * Claim an unclaimed account by setting password
     * @returns any Account claimed successfully
     * @throws ApiError
     */
    public postAccessClaim({
        token,
        requestBody,
    }: {
        token: string,
        requestBody?: {
            name: string;
            email: string;
            password: string;
        },
    }): CancelablePromise<{
        message: string;
        userId: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/access/{token}/claim',
            path: {
                'token': token,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Account already claimed or invalid request`,
                404: `Invalid token`,
            },
        });
    }

    /**
     * Regenerate access token for a customer (trainers only)
     * @returns any Token regenerated
     * @throws ApiError
     */
    public postAccessRegenerate({
        customerId,
    }: {
        customerId: string,
    }): CancelablePromise<{
        accessToken: string;
        accessUrl: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/access/regenerate/{customerId}',
            path: {
                'customerId': customerId,
            },
            errors: {
                403: `Forbidden`,
                404: `Customer not found`,
            },
        });
    }

}
